import {
  IS_NOTIFICATION_RECEIVED,
  SET_NOTIFICATION_TEXT,
} from "constants/ActionTypes";

export const isNotificationReceived = () => {
  return {
    type: IS_NOTIFICATION_RECEIVED,
  };
};
export const setNotificationText = (payload) => {
  return {
    type: SET_NOTIFICATION_TEXT,
    payload: payload,
  };
};
